import { render } from "./CloneFacilityHistoryModal.vue?vue&type=template&id=56154153"
import script from "./CloneFacilityHistoryModal.vue?vue&type=script&lang=js"
export * from "./CloneFacilityHistoryModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__